import { GetDeploymentRulesRequestDTO } from '@gearbelt/global';
import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';

import { ApiService } from '@/services/api-v2';

export const deploymentRuleKeys = {
  all: ['deployment-rules'] as const,
  infinite: (search: string, orderBy?: GetDeploymentRulesRequestDTO['orderBy']) => [...deploymentRuleKeys.all, 'infinite', search, orderBy] as const,
  detail: (id: string | undefined) => [...deploymentRuleKeys.all, 'detail', id] as const,
  recalcRun: (runId: string | undefined) => [...deploymentRuleKeys.all, 'recalc-run', runId] as const,
};

export const getDeploymentRulesInfiniteQueryOptions = ({
  search,
  orderBy,
  enabled = true,
}: {
  search: string;
  orderBy?: GetDeploymentRulesRequestDTO['orderBy'];
  enabled?: boolean;
}) => {
  return infiniteQueryOptions({
    queryKey: deploymentRuleKeys.infinite(search, orderBy),
    queryFn: async ({ pageParam }: { pageParam?: string }) =>
      await (await ApiService.GetDeploymentRules({ limit: 30, cursors: pageParam, filters: { search }, orderBy })).json(),
    getNextPageParam: (lastPage) => (lastPage.pageInfo.hasNextPage ? lastPage.pageInfo.endCursor : undefined),
    initialPageParam: undefined as string | undefined,
    retry: false,
    gcTime: 0,
    enabled,
  });
};

export const getDeploymentRuleQueryOptions = ({ id }: { id: string | undefined }) => {
  return queryOptions({
    queryKey: deploymentRuleKeys.detail(id),
    queryFn: async () => {
      if (!id) throw new Error('Deployment rule ID is required');
      return (await (await ApiService.GetDeploymentRule(id)).json()).deploymentRule;
    },
    enabled: !!id,
  });
};
